import React from 'react';
import Item from '../DropdownItem/DropdownItem';
import {
    IconHighlightL,
    IconMoneyL,
    IconPencilLetterL,
    IconRocketL,
    IconSpeakerL,
    IconTeamL,
} from '../../../../icons';

export default () => (
    <>
        <Item name="AboutUs">
            <Item.Icon>
                <IconRocketL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Unser Startup</Item.Heading>
                <Item.Description>Vision und Mission</Item.Description>
            </Item.Content>
        </Item>
        <Item name="CareerPage" hash="#team">
            <Item.Icon>
                <IconHighlightL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Team</Item.Heading>
                <Item.Description>Lerne uns kennen</Item.Description>
            </Item.Content>
        </Item>
        <Item name="KodexPage">
            <Item.Icon>
                <IconPencilLetterL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Kodex</Item.Heading>
                <Item.Description>Unsere Werte</Item.Description>
            </Item.Content>
        </Item>
        <Item name="ForClubs">
            <Item.Icon>
                <IconTeamL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Für Vereine</Item.Heading>
                <Item.Description>Kostenlose Unterstützung</Item.Description>
            </Item.Content>
        </Item>
        <Item name="BecomePartnerPage">
            <Item.Icon>
                <IconSpeakerL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Für Unternehmen</Item.Heading>
                <Item.Description>Werbemöglichkeiten</Item.Description>
            </Item.Content>
        </Item>
    </>
);
